require("../coord/parallel/parallelCreator");

require("./axis/parallelAxisAction");

require("./axis/ParallelAxisView");


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/parallelAxis.js
// module id = 1320
// module chunks = 106